module.exports = __webpack_public_path__ + "img/Grouphonor-top.ec806b2c.png";